import React from 'react';
import Timer from './components/Timer';
import "./styles/button.css"; 

const App = () => <Timer />

export default App;